import { Box, Flex, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const CARD_MAX_WIDTH = pxToRem(400);
const DESKTOP_PADDING_X = pxToRem(360);
const CONTENT_MAX_WIDTH = pxToRem(1032);
const PROGRESS_BAR_HEIGHT = pxToRem(8);

export const Container = styled(Flex)`
  max-width: ${CONTENT_MAX_WIDTH};
`;

export const FundCard = styled(Box)`
  max-width: ${CARD_MAX_WIDTH};
`;

export const FundPhotoContainer = styled(Box)`
  padding-top: 66.75%;
`;

export const FundPhoto = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

export const ProgressBarContainer = styled(Box)`
  height: ${PROGRESS_BAR_HEIGHT};
  position: relative;
`;

export const ProgressBarFill = styled(Box)`
  height: 100%;
  background-color: #176f69;
  border-radius: 100px;
  transition: width 0.3s ease;
  position: absolute;
  top: 0;
  left: 0;
`;

export const ProgressBarPreview = styled(Box)`
  height: 100%;
  background-color: rgba(23, 111, 105, 0.4);
  border-radius: 100px;
  transition: width 0.3s ease;
  position: absolute;
  top: 0;
  left: 0;
`;

export const styles = {
  cardMaxWidth: CARD_MAX_WIDTH,
  desktopPaddingX: DESKTOP_PADDING_X,
  contentMaxWidth: CONTENT_MAX_WIDTH,
  progressBarHeight: PROGRESS_BAR_HEIGHT,
};
